export const scenarioTypes = {
    SET_ACTIVE_SCENARIOS: 'SET_ACTIVE_SCENARIOS',
    SET_USER_SCENARIOS: 'SET_USER_SCENARIOS',
    REMOVE_SCENARIO: 'REMOVE_SCENARIO',
}
